import React from "react";

export const Creator = () => {
  return (
    <div className="creator">
      <p>Created by Efe Samuel</p>
    </div>
  );
};
